import { render, staticRenderFns } from "./receber-parcela-lote.vue?vue&type=template&id=42a788d9&scoped=true"
import script from "./receber-parcela-lote.vue?vue&type=script&lang=js"
export * from "./receber-parcela-lote.vue?vue&type=script&lang=js"
import style0 from "./receber-parcela-lote.vue?vue&type=style&index=0&id=42a788d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a788d9",
  null
  
)

export default component.exports